import styled from 'styled-components';

// Helpers
import { card } from '~/App/helpers/mixins';

export const ColumnCard = styled.div`
  ${card}
`;
